import { useState } from 'react';
import { TongueDrag } from '@/ui/tongue3d/TongueDrag';
import type { DragZone } from '@/ui/tongue3d/dragZone';

const SAY: Record<DragZone, string> = {
  low: 'Lift the middle of the tongue higher',
  right: 'Just right: close to the roof, not touching',
  touch: 'Touching the roof: let it down a tiny bit',
};

/** Development page (`?tonguedrag`): drag the middle of the tongue up toward the roof. */
export function TongueDragPreview() {
  const [zone, setZone] = useState<{ zone: DragZone; gap: number } | null>(null);
  const [done, setDone] = useState<string>('');
  return (
    <main style={{ padding: 16, background: '#0b1a3a', minHeight: '100vh', color: 'white' }}>
      <p data-testid="zone" style={{ fontSize: 20, margin: '0 0 8px' }}>
        {zone ? `${SAY[zone.zone]} (${zone.gap.toFixed(1)} mm)` : 'Drag the blue dot up'}
      </p>
      <p data-testid="done" style={{ margin: '0 0 8px', opacity: 0.8 }}>
        {done}
      </p>
      <div
        style={{
          width: '100%',
          maxWidth: 900,
          aspectRatio: '4 / 3',
          background: '#e8f0fb',
          borderRadius: 16,
        }}
      >
        <TongueDrag
          label="The mouth from the side; drag the middle of the tongue up"
          onZone={(z, gap) => {
            setZone({ zone: z, gap });
          }}
          onDone={(z, gap) => {
            setDone(`Let go: ${z} (${gap.toFixed(1)} mm)`);
          }}
        />
      </div>
    </main>
  );
}
